import { BeaconStartTourComponent } from "./BeaconStartTourComponent";

export const START_OF_TOUR_PROPS = {
  target: ".startGuidedTourBeaconLocation",
  beaconComponent: props => {
    return (
      <BeaconStartTourComponent
        onClick={props.onClick}
        className="react-joyride__beacon"
      />
    );
  },
  styles: {
    spotlight: {
      border: "none",
      boxShadow: "none",
    },
  },
};
